// Ticks the ?qty= pack before first paint, so it doesn't visibly jump from the 1-pack.
// Loaded blocking right after the tiles; product-custom.js does the rest on DOMContentLoaded.
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    // xvd traffic hides the multipack — leave the default alone.
    if (params.get('xvd') === '1' || sessionStorage.getItem('xvd_found') === 'true') return;

    var requested = params.get('qty');
    if (!requested) return;

    var shown = document.querySelector('.main-bulk-buy .bulk-buy-inner:not(.hidden)');
    if (!shown) return;

    // Packs come from the rendered tiles, not a hardcoded list: this store's are
    // 1 / 2 / 3, hardcoded in snippets/bulk-buy.liquid (no quantity_*_block settings here).
    var labels = shown.querySelectorAll('label.bulk-buy[data-qty]');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].getAttribute('data-qty') !== requested) continue;
      var input = labels[i].querySelector('input[name="bulk_buy_qty"]');
      // Only :checked — the highlight is pure CSS.
      if (input) input.checked = true;
      return;
    }
    // Not one of the rendered packs: keep the server-rendered 1-pack.
  } catch (e) {}
})();
